import { AuraFilters } from '@/types/models/AuraFiltersModel';

export interface AuraConversation {
    id: number;
    levelId: number;
    userId: number;
    title: string;
    status: 'active' | 'archived' | 'deleted';
    context?: {
        filters?: AuraFilters;
        verticalId?: number;
        dateRange?: {
            start: string;
            end: string;
        };
    };
    createdAt: string;
    updatedAt?: string;
    deletedAt?: string;
}
